import isEmpty from 'lodash/isEmpty'

export function toggleOneClickCheckout() {
    return function (dispatch, getState) {
        const state = getState()
        const userLoggedIn = state.user.isLoggedIn
        const hasActiveAddress = !isEmpty(state.address.active)
        const hasPreferredPaymentMethod = !isEmpty(state.paymentMethod.preferred)
        const hasFilledOutContactInfo =
            !isEmpty(state.personalInfo.firstName) && !isEmpty(state.personalInfo.lastName)
        const oneClickCheckoutEnabled = state.features.oneClickCheckoutEnabled

        if (
            userLoggedIn &&
            hasActiveAddress &&
            hasPreferredPaymentMethod &&
            hasFilledOutContactInfo &&
            !oneClickCheckoutEnabled
        ) {
            dispatch({ type: 'FEATURE_TOGGLE_ONE_CLICK_CHECKOUT', payload: true })
        }

        if (
            (!userLoggedIn ||
                !hasActiveAddress ||
                !hasPreferredPaymentMethod ||
                !hasFilledOutContactInfo) &&
            oneClickCheckoutEnabled
        ) {
            dispatch({ type: 'FEATURE_TOGGLE_ONE_CLICK_CHECKOUT', payload: false })
        }
    }
}
